<template>
  <span>
    <span
      :class="{'text-bold' : bold}"
      :id="model.$form.generateId ? model.$pathId : undefined"
      :data-path="model.$form.testPath ? model.$path : undefined"
    >{{value}}</span>
    <w-error v-if="showError" :model="model"></w-error>
  </span>
</template>

<script>
import WError from './error.vue';
export default {
  components: {WError},
  props: {
    model: Object,
    bold: Boolean,
    values: Array,
    valueKey: {type: String, default: 'value'},
    valueText: {type: String, default: 'text'},
    default: {
      type: String,
      default: ''
    },
    showError: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    value: {
      get() {
        if (!this.model) {
          return '';
        }
        if (!this.values) {
          if (this.model.$value.length === 0 && this.default.length > 0) {
            return this.default;
          }
          return this.model.$value;
        }

        const key = this.valueKey || 'value';
        const textKey = this.valueText || 'text';
        const value = this.values.find(item => {
          return item[key] === this.model.$value;
        });
        if (value === undefined) {
          return '';
        }
        return value[textKey];
      }
    }
  }
};
</script>



